import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { EXPERIMENT_QUERY_ACTIVE_VARIANT } from '@gig/magic-messages';

/**
 * Conditionally renders a slot with the active running experiment
 * variant.
 */
var ExperimentComponent = /** @class */ (function (_super) {
    __extends(ExperimentComponent, _super);
    function ExperimentComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeExperimentVariant = false;
        return _this;
    }
    ExperimentComponent.prototype.getActiveExperimentVariantName = function () {
        var activeExperiment = this.activeExperimentVariant;
        if (!activeExperiment) {
            return this.default || false;
        }
        return activeExperiment.name;
    };
    ExperimentComponent.prototype.created = function () {
        var _this = this;
        window.queryBus.query(EXPERIMENT_QUERY_ACTIVE_VARIANT, this.name, function (experiment) {
            return (_this.activeExperimentVariant = experiment);
        });
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], ExperimentComponent.prototype, "name", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], ExperimentComponent.prototype, "default", void 0);
    ExperimentComponent = __decorate([
        Component({
            name: 'experiment',
        })
    ], ExperimentComponent);
    return ExperimentComponent;
}(Mixins(MagicConfigMixin)));

export default ExperimentComponent;
